// extracted by css-extract-rspack-plugin
export default {"wrapper":"sSqafqsCxicXlI8r","group":"kSwNsSwAEaIwYDZj","search":"ozZBOSjc30sNDLsY","checkbox":"fXS0U2NLKgOp0ajp"};